import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { ProductsView } from "./ProductsView";
// import { CollectionsView } from "./CollectionsView";
import { ActionType } from "./lib/reducer";
// import { MENS, WOMENS } from "./lib/constants";
import { TYPE, SIZE, COLOUR_TAGS } from "@components/Filter/constants";
import { Filter } from "@components/Filter";
import { FilterMenuMobile } from "@components/Filter/Mobile";

export function Products({
  collection,
  // collectionOrders,
  productList,
  state,
  dispatch,
  filteredValues,
  clearFilters,
  filterLabels,
  onChange,
  sortBy,
  setSortBy,
}) {
  const { ref, inView } = useInView({ threshold: 0 });
  const loadMoreProducts = () => dispatch({ type: ActionType.DISPLAY_MORE_PRODUCTS });

  useEffect(() => {
    if (inView) {
      loadMoreProducts();
    }
  }, [inView]);


  return (
    <>
      {collection && (
        <>
          <Filter
            activeFilters={[TYPE, SIZE, COLOUR_TAGS]}
            products={productList}
            filterLabels={filterLabels}
            filteredValues={filteredValues}
            onChange={onChange}
            sortBy={sortBy}
            setSortBy={setSortBy}
          />
          <FilterMenuMobile
            activeFilters={[TYPE, SIZE, COLOUR_TAGS]}
            products={productList}
            filterLabels={filterLabels}
            filteredValues={filteredValues}
            onChange={onChange}
            sortBy={sortBy}
            setSortBy={setSortBy}
          />
        </>
      )}
      <ProductsView
        collection={collection.handle}
        contentSections={collection.contentSectionsRef}
        showContentFirst={collection.showContentFirst}
        state={state}
        paginationRef={ref}
        loadMoreProducts={loadMoreProducts}
        filteredValues={filteredValues}
        clearFilters={clearFilters}
        productList={productList}
      />
    </>
  );
}